import { Accordion } from "@app/shared/Accordion"
import { FC, useContext, useRef } from "react"
import { ProviderHubContext } from "@app/projects/network-assessment/provider-hub/contexts/ProviderHubContext";
import { CountyProjectContext } from "@app/projects/CountyProjectContext";
import formatPhoneNumber from "@app/shared/formatPhoneNumber";
import { QESButton } from "@app/shared/qes-standards/Button";
import { ProviderProfileReferrerEnum } from "@app/projects/network-assessment/provider-hub/provider-profile/interfaces/providerProfileReferrerEnum";
import ProviderHubService from "@app/projects/network-assessment/provider-hub/providerHubService";
import { ContractEntitySubTypeEnum } from "@app/projects/enumerators";

export const HospitalProfileEntityBreakdown: FC = () => {
  const providerHubContext = useContext(ProviderHubContext);
  const projectContext = useContext(CountyProjectContext);
  const { selectedHospital } = providerHubContext;
  const providerHubService = useRef(new ProviderHubService()).current;

  const contractEntityId = Number(selectedHospital.contractEntityId);
  const hasContractEntity = !!selectedHospital.contractEntityName && !Number.isNaN(contractEntityId);

  const handleContractEntityClick = async () => {
    const contractEntity = await providerHubService.getContractEntityDetails(
      projectContext?.project?.projectId,
      selectedHospital.projectRunConfigurationId,
      contractEntityId
    );
    providerHubContext.navigateToContractEntityProfile(contractEntity, ProviderProfileReferrerEnum.HospitalProfile);
  };

  return (
    <Accordion title="Entity Breakdown" testId="hospital-profile__entity-breakdown-accordion" defaultOpen={true} className="provider-profile__overview">
      <dl>
        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Name</dt>
          <dd className="provider-profile__overview-value">
            {hasContractEntity ? (
              <QESButton
                qesType="link"
                qesTestId={`hospital-profile__contract-entity--${selectedHospital.contractEntityName}`}
                onClick={() => { handleContractEntityClick() }}
                className="demibold"
              >
                {selectedHospital.contractEntityName}
              </QESButton>
            ) : (selectedHospital.contractEntityName ?? "---")}
          </dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Type</dt>
          <dd className="provider-profile__overview-value">{ContractEntitySubTypeEnum[selectedHospital.contractEntityType as keyof typeof ContractEntitySubTypeEnum] ?? "---"}</dd>
        </div>

        <div className="provider-profile__overview-row">
          <dt className="provider-profile__overview-label">Phone Number</dt>
          <dd className="provider-profile__overview-value">{formatPhoneNumber(selectedHospital.phoneNumber)}</dd>
        </div>
      </dl>
    </Accordion>
  )
};
